import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import useFabricDetails from 'data-hooks/useFabricDetails';
import useFabricReviews from 'data-hooks/useFabricReviews';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_FABRIC_GALLERY_DATA } from 'mocks/queries';
import PDPFabricDetailSidebarUI from './PDPFabricDetailSidebarUI';
const PDPFabricDetailSidebar = t0 => {
  const $ = _c(22);
  const {
    isOpen,
    onClose,
    fabricId,
    mode: t1,
    galleryType,
    mobileHideHeader
  } = t0;
  const mode = t1 === undefined ? "pdp" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      w: 1800,
      h: 915
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const zoomImgProps = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      height: 300,
      width: 590
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const jbImgProps = t3;
  const {
    loading,
    error,
    data: t4
  } = useFabricDetails(fabricId);
  const {
    selectedFabric
  } = t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      variables: {
        fromCache: true
      }
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const {
    data: fabricsGalleryData
  } = useSuspenseQuery(GET_FABRIC_GALLERY_DATA, t5);
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      auto: "format,compress",
      fit: "fill",
      crop: "entropy",
      h: 430,
      w: 875
    };
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const imgProps = t6;
  let t7;
  if ($[4] !== fabricsGalleryData?.getFabricGalleryData || $[5] !== selectedFabric) {
    t7 = () => {
      const itemData = fabricsGalleryData?.getFabricGalleryData ?? {};
      if (selectedFabric && Object.keys(selectedFabric).length > 0) {
        Object.keys(itemData).forEach(key => {
          if (key === `${selectedFabric?.option_value_id}`) {
            let itemGalleryData = itemData[key];
            if (itemGalleryData) {
              ;
              try {
                itemGalleryData = JSON.parse(itemGalleryData);
              } catch (t8) {
                itemGalleryData = null;
              }
            }
            const {
              img_prefix: t9,
              img_suffixes: t10
            } = itemGalleryData;
            const img_prefix = t9 === undefined ? "" : t9;
            const img_suffixes = t10 === undefined ? "" : t10;
            const img_suffixesList = img_suffixes.length ? img_suffixes.split(",") : null;
            const images = [];
            for (let i = 0; i < img_suffixesList?.length; i++) {
              const obj = {
                url: "https://joybird2.imgix.net/fabric-swatches/t1/".concat(img_prefix, `-t1-${img_suffixesList[i]}.jpg`),
                isVideo: false,
                imgProps,
                zoomUrl: "https://joybird2.imgix.net/fabric-swatches/t1/".concat(img_prefix, `-t1-${img_suffixesList[i]}.jpg`),
                videoProps: {},
                className: "",
                zoomImgProps,
                jbImgProps
              };
              images.push(obj);
            }
            selectedFabric.sliderImages = images;
          }
        });
      }
    };
    $[4] = fabricsGalleryData?.getFabricGalleryData;
    $[5] = selectedFabric;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== fabricsGalleryData || $[8] !== selectedFabric) {
    t8 = [fabricsGalleryData, selectedFabric];
    $[7] = fabricsGalleryData;
    $[8] = selectedFabric;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  useEffect(t7, t8);
  const {
    loading: reviewsLoading,
    error: reviewsError,
    data: t9
  } = useFabricReviews(fabricId);
  const {
    reviews,
    rating
  } = t9;
  if (error) {
    return null;
  }
  let t10;
  if ($[10] !== galleryType || $[11] !== isOpen || $[12] !== loading || $[13] !== mobileHideHeader || $[14] !== mode || $[15] !== onClose || $[16] !== rating || $[17] !== reviews || $[18] !== reviewsError || $[19] !== reviewsLoading || $[20] !== selectedFabric) {
    t10 = <PDPFabricDetailSidebarUI isOpen={isOpen} loading={loading} mode={mode} onClose={onClose} rating={rating} reviews={reviews} reviewsError={reviewsError} reviewsLoading={reviewsLoading} selectedFabric={selectedFabric} galleryType={galleryType} mobileHideHeader={mobileHideHeader} />;
    $[10] = galleryType;
    $[11] = isOpen;
    $[12] = loading;
    $[13] = mobileHideHeader;
    $[14] = mode;
    $[15] = onClose;
    $[16] = rating;
    $[17] = reviews;
    $[18] = reviewsError;
    $[19] = reviewsLoading;
    $[20] = selectedFabric;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
PDPFabricDetailSidebar.propTypes = {
  fabricId: PropTypes.number,
  isOpen: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onClose: PropTypes.func,
  galleryType: PropTypes.string,
  mobileHideHeader: PropTypes.bool
};
export default PDPFabricDetailSidebar;